<template>
  <div class="content-block news-slide">
    <div class="content-block__swiper__slide">
      <div class="content-block__swiper__slide__text">
        <div>
          <div
            v-if="item?.title"
            class="content-block__swiper__slide__title title-medium3 is-medium-bold"
          >
            <p v-html="item.title" />
          </div>
          <div
            v-if="item?.introNews?.html"
            class="content-block__swiper__slide__description text-medium5"
          >
            <div v-html="item.introNews.html" />
          </div>
        </div>
        <div>
          <NuxtLink
            :to="
              localePath({
                name: 'news-slug',
                params: { slug: item.slug },
              })
            "
          >
            <div class="text-medium5 default-icon-btn is-medium-bold">
              <span>{{ $t('common.approfondisci') }}</span>
              <ArrowIcon alt="Arrow icon" class="icon-arrow" />
            </div>
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import ArrowIcon from '@/assets/img/ico/arrow-mobile.svg'

const props = defineProps({
  item: {
    type: Object,
    default: () => ({}),
  },
})
</script>

<script>
export default {
  name: 'IconSlide',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
